import axios from 'axios';
import type { OnboardingPublic } from '@scriptpad/shared';

const baseURL = import.meta.env.VITE_API_BASE ?? 'http://localhost:4000';

export const api = axios.create({ baseURL, timeout: 30000 });

export const fetchOnboarding = async (guid: string): Promise<OnboardingPublic> => {
  const { data } = await api.get<OnboardingPublic>(`/v1/onboarding/${guid}`);
  return data;
};

export const updateStep = async (guid: string, currentStep: number): Promise<OnboardingPublic> => {
  const { data } = await api.patch<OnboardingPublic>(`/v1/onboarding/${guid}/step`, { currentStep });
  return data;
};

export const setPracticeMode = async (
  guid: string,
  mode: 'organisation' | 'sole_practitioner',
): Promise<OnboardingPublic> => {
  const { data } = await api.post<OnboardingPublic>(`/v1/onboarding/${guid}/practice-mode`, { mode });
  return data;
};

export const acceptGovernance = async (
  guid: string,
  agreementVersion: string,
): Promise<OnboardingPublic> => {
  const { data } = await api.post<OnboardingPublic>(`/v1/onboarding/${guid}/governance-agreement`, {
    agreementVersion,
  });
  return data;
};

export const uploadNashCert = async (
  guid: string,
  file: File,
  pic: string,
): Promise<OnboardingPublic> => {
  const form = new FormData();
  form.append('file', file);
  form.append('pic', pic);
  const { data } = await api.post<OnboardingPublic>(`/v1/onboarding/${guid}/nash-cert`, form, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};

export const submitHpiI = async (guid: string, hpiI: string): Promise<OnboardingPublic> => {
  const { data } = await api.post<OnboardingPublic>(`/v1/onboarding/${guid}/hpi-i`, { hpiI });
  return data;
};

export const fetchIdentityToken = async (
  guid: string,
): Promise<{ token: string; userId: string; applicantId: string }> => {
  const { data } = await api.post(`/v1/onboarding/${guid}/identity/token`);
  return data;
};

export const refreshIdentityStatus = async (guid: string): Promise<OnboardingPublic> => {
  const { data } = await api.post<OnboardingPublic>(`/v1/onboarding/${guid}/identity/refresh`);
  return data;
};

export const completeOnboarding = async (guid: string): Promise<OnboardingPublic> => {
  const { data } = await api.post<OnboardingPublic>(`/v1/onboarding/${guid}/complete`);
  return data;
};
